const developRouterMap = [
  {
    name: "develop",
    path: "/develop",
    component: () => import("@/views/develop"),
    children: [
      {
        name: "webpage",
        path: "webpage",
        component: () => import("@/views/develop/webpage"),
        meta: { title: "创建新页面" },
      },
      {
        name: "table",
        path: "table",
        component: () => import("@/views/develop/table"),
        meta: { title: "table表格" },
      },
      // {
      //   name: "mock",
      //   path: "mock",
      //   component: () => import("@/views/develop/mock"),
      //   meta: { title: "Mock" },
      // },
      // {
      //   name: "validate",
      //   path: "validate",
      //   component: () => import("@/views/develop/validate"),
      //   meta: { title: "有效性检查" },
      // },
      {
        name: "utils",
        path: "utils",
        component: () => import("@/views/develop/utils"),
        meta: { title: "公共函数" },
      },
      {
        name: "pattern",
        path: "pattern",
        component: () => import("@/views/develop/pattern"),
        meta: { title: "正则表达式" },
      },
    ],
  },
];
export default developRouterMap;